export const genderFilterOptions = [
  { value: 1, label: "child-page-gender-filter-male-option-label" },
  { value: 2, label: "child-page-gender-filter-female-option-label" },
];
